import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconTimeEndFill.tsx
const IconTimeEndFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ jsx("path", { d: "M30.16 28.432a6 6 0 0 1-.778.95 6 6 0 0 1-.95.779l-3.37-3.372-3.371 3.371a6.1 6.1 0 0 1-1.729-1.729l3.37-3.37-3.37-3.371q.334-.505.778-.95.445-.444.95-.779l3.371 3.371 3.37-3.37a6.1 6.1 0 0 1 1.73 1.728l-3.371 3.371z" }), /* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			d: "M16.506 25.06a8.5 8.5 0 0 0 .658 3.298 13.5 13.5 0 0 1-2.48.14C7.546 28.24 1.839 22.372 1.839 15.172c0-7.364 5.97-13.334 13.333-13.334 7.2 0 13.068 5.707 13.325 12.845a13.7 13.7 0 0 1-.139 2.48 8.5 8.5 0 0 0-3.297-.659 8.53 8.53 0 0 0-4.59 1.334 8.55 8.55 0 0 0-3.965 7.222m4.077-9.887a11 11 0 0 0-3.61 2.666H13.84V8.506h2.667v6.667z",
			clipRule: "evenodd"
		})]
	})]
});
var IconTimeEndFill_default = forwardRef(IconTimeEndFill);
//#endregion
export { IconTimeEndFill_default as default };
